import React, { Component } from 'react';
import { connect } from 'react-redux';
import { telechargerFichier } from '../../App_Code/API';
import { toDate, toEuros, estEnCoursDeChargement } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Chargement from '../Chargement';
import SelecteurDate from '../SelecteurDate';
import Tableau from '../Tableau';

const TABLEAU_LENGENDE = [
    { titre: 'En-cours', classe: 'table-warning' }, // 0
    { titre: 'Exercice courant', classe: '' }, // 1
    { titre: 'Hors exercice courant', classe: 'table-primary' }, // 2
    { titre: 'A approuver', classe: 'table-violet' }, // 3
];

const Legende = () => (
    <span>
        <span className="col-form-label">Légende :</span>
        {TABLEAU_LENGENDE.map((ligne, i) => (
            <span className={`p-2 border ml-1 ${ligne.classe}`} key={i}>
                {ligne.titre}
            </span>
        ))}
    </span>
);

const AlertePasDeLigne = () => (
    <div className="jumbotron text-center">
        <h1 className="display-4">Aucune ligne d&apos;historique.</h1>
    </div>
);

const LigneHistorique = ({
    Etat, DateEcr, Libelle, Lot, Bnq, Cheque, Debit, Credit, Solde, Fichier,
}) => (
    <tr className={TABLEAU_LENGENDE[Etat].classe}>
        <th>{toDate(DateEcr, 'L')}</th>
        <td>{Libelle}</td>
        <td>{Lot}</td>
        <td>{Bnq}</td>
        <td>{Cheque === '0' ? '' : Cheque}</td>
        <td className="text-right">{toEuros(Debit)}</td>
        <td className="text-right">{toEuros(Credit)}</td>
        <td className={`text-right ${Solde < 0 ? 'text-danger' : ''}`}>{toEuros(Solde, true)}</td>
        <td className="text-right">
            {Fichier && (
                <a target="_blank" href={telechargerFichier(Fichier, false)}>
                    <i className="fa fas fa-download mr-3" title="Télécharger le document" />
                </a>
            )}
        </td>
    </tr>
);

const AfficherTableau = ({ historique }) => {
    const Entete = (
        <tr>
            <th scope="col">Date</th>
            <th scope="col">Libellé</th>
            <th scope="col">Lot</th>
            <th scope="col">Banque</th>
            <th scope="col">Chèque</th>
            <th scope="col" className="text-right">
                Débit
            </th>
            <th scope="col" className="text-right">
                Crédit
            </th>
            <th scope="col" className="text-right">
                Solde
            </th>
            <th scope="col" className="text-right">
                Doc
            </th>
        </tr>
    );

    const Lignes = historique.map((histo, i) => <LigneHistorique key={i} {...histo} />);

    return (
        <div className="table-responsive">
            <Tableau Entete={Entete} Lignes={Lignes} />
        </div>
    );
};

class PageHistoCompta extends Component {
    state = {
        dateDebut: new Date(this.props.DateDebExeCourant),
    };

    ChangementDate = (dateDebut) => {
        if (dateDebut) {
            this.setState({
                dateDebut,
            });
        }
    };

    render() {
        const { dateDebut } = this.state;
        const { Historique } = this.props;
        if (estEnCoursDeChargement(Historique)) return <Chargement />;

        const DateTime = new Date(dateDebut).getTime();
        const fHistorique = Historique.filter(ligne => new Date(ligne.DateEcr).getTime() >= DateTime);

        return (
            <React.Fragment>
                <div className="d-flex justify-content-between mb-2">
                    <SelecteurDate label="À partir du : " valeurDate={dateDebut} onDayChange={this.ChangementDate} />
                    <Legende />
                </div>
                {fHistorique.length === 0 ? <AlertePasDeLigne /> : <AfficherTableau historique={fHistorique} />}
            </React.Fragment>
        );
    }
}
PageHistoCompta.displayName = 'PageHistoCompta';
PageHistoCompta.requiredProps = [
    'DateDebExeCourant', // Date de début de l'exercice courant
    'Historique', // Historique comptable
];

function mapStateToProps({
    CopStore: {
        Cop: { DateDebExeCourant },
    },
    ProStore: { Historique },
}) {
    return { DateDebExeCourant, Historique };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(PageHistoCompta));



// WEBPACK FOOTER //
// ./src/components/MesInfos/PageHistoCompta.js